import { render } from "./AddUsers.vue?vue&type=template&id=973f19ae"
import script from "./AddUsers.vue?vue&type=script&lang=js"
export * from "./AddUsers.vue?vue&type=script&lang=js"

import "./AddUsers.vue?vue&type=style&index=0&id=973f19ae&lang=scss"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__